var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LoadingView"},[_c('v-container',{staticClass:"fill-height"},[_c('v-row',[_c('v-col',{attrs:{"align-self":"center","align":"center"}},[_c('v-img',{attrs:{"src":require('@/assets/logos/logo.icon.svg'),"contain":"","width":"300px"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }